module.exports = __webpack_public_path__ + "img/ico_attachment.0c8d2699.svg";